<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                Add quote block type
            </h2>
        </template>
        <quote-block-type-form></quote-block-type-form>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout';
import QuoteBlockTypeForm from "@/Pages/Admin/QuoteBlockType/Partials/QuoteBlockTypeForm";

export default {
    components: {
        QuoteBlockTypeForm,
        AppLayout,
    },
}
</script>
